module.exports = __webpack_public_path__ + "static/media/42.84ebfb3e.jpg";